import { render, staticRenderFns } from "./TabDRE.vue?vue&type=template&id=dd7f1ee8&"
import script from "./TabDRE.vue?vue&type=script&lang=js&"
export * from "./TabDRE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports